import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { IPropertySearchCriteria } from '../../../shared/models/propertysearchcriteria';
import { LoaderService } from '../../../shared/providers/loader.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import * as moment from 'moment';
import { AuthenticationService } from '../../../shared/auth/authentication.service';

@Component({
  selector: 'app-portfolio-property-list',
  templateUrl: './portfolio-property-list.component.html'
})
export class PortfolioPropertyListComponent implements OnInit {

  constructor(private _propertyListingService: PropertyListingService, public authService: AuthenticationService, private _loaderService: LoaderService, private _changeDetectorRef: ChangeDetectorRef,
    private _validationService: ValidationService) { }

  @Input() propertyGuid: string;
  @Input() property: any;
  @Input() leadDetailsGuid: string;
  @Input() selectedPropertyIds = [] as number[];
  @Input() selectAllStatus = false as boolean;
  @Input() Isunpriced: string = '2';
  @Input() Iszcf: string = '2';
  @Output() save = new EventEmitter();
  @Output() show = new EventEmitter();
  haveaccesstoviewlocation: boolean = true;
  haveaccesstoviewlocation1: boolean = true;
  propertySearchCriteria = {} as IPropertySearchCriteria;
  propertylist = [] as any[];
  selectAll: boolean;
  askingPrice: number;
  noi: number;
  capRate: any;
  avgRemainingTerm: any;
  avgArea: number;
  UnPriced?: boolean;
  zcf?: boolean;
  ngOnInit() {
    this.selectAll = this.selectAllStatus
    this.loadPortfolioProperties();
    if (!this.authService.Admin() && !this.authService.SuperAdmin() && !this.authService.Broker() && !this.authService.DataEntryStaff()) {
      this.haveaccesstoviewlocation = false;
    }
    else {
      this.haveaccesstoviewlocation = true;
    }
  }

  loadPortfolioProperties() {
    this._loaderService.display(true);
    if (this.property != null) {
      if (this.property.ConfidentialLocation != undefined) {
        if (!this.haveaccesstoviewlocation && this.property.ConfidentialLocation) {
          this.haveaccesstoviewlocation = false;
        }
      }
      this.propertySearchCriteria.PropertyId = this.property.Id;
      if (this.property.Unpriced != null) {
        this.UnPriced = this.property.Unpriced;
        this.zcf = this.property.OnlyZCF;

      }
    }
    else {
      if (this.Isunpriced != '2') {
        this.UnPriced = this.Isunpriced == '1' ? true : false;
      }
      if (this.Iszcf != '2') {
        this.zcf = this.Iszcf == '1' ? true : false;
      }
    }
    this.propertySearchCriteria.LeadDetailsGuid = this.leadDetailsGuid;
    this._propertyListingService.GetPortfolioPropertiesList(this.propertySearchCriteria).subscribe(item => {
      item.forEach(date => {
        if (this.selectAll || this.leadDetailsGuid != null) {
          date.IsChecked = true;
          this.selectedPropertyIds.push(date.Id)
        }
        else {
          date.IsChecked = this.selectedPropertyIds.includes(date.Id);
        }
        this.propertylist.push(date);
      })

      var parent = this.propertylist.filter(i => i.IsPortfolio);
      if (this.leadDetailsGuid != null && parent.length > 0) {
        if (parent[0].IsCompletePortfolio) {
          this.selectAll = true;
        }

        this.property = parent[0];
        this.propertylist.splice(this.propertylist.findIndex(x => x.IsPortfolio), 1);
      }
      this.calcSelectePropertyAverage(this.selectedPropertyIds);
      this._loaderService.display(false);
    });
  }

  emitOnCheck() {
    var propList = this.propertylist.filter(x => this.selectedPropertyIds.includes(x.Id));
    var askingPrice = this.askingPrice;
    this.save.emit({ propList, askingPrice });
  }

  showPlaceOffer() {
    this.show.emit();
  }

  onSelectAll(isChecked) {

    this.propertylist.forEach(item => item.IsChecked = isChecked);
    if (isChecked) {
      this.selectedPropertyIds = this.propertylist.map(t => t.Id);
    }
    else {
      this.selectedPropertyIds = [];
      this.UnPriced = false;
    }

    this.calcSelectePropertyAverage(this.selectedPropertyIds);
  }

  onSelect(IsChecked, item) {

    if (IsChecked) {
      if (this.selectedPropertyIds.findIndex(x => x == item.Id) == -1) {
        this.selectedPropertyIds.push(item.Id);
      }
    }
    else {
      this.selectedPropertyIds.splice(this.selectedPropertyIds.findIndex(x => x == item.Id), 1);
    }

    if (this.selectedPropertyIds.length == this.propertylist.filter(i => !i.IsPortfolio).length) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
    this.calcSelectePropertyAverage(this.selectedPropertyIds);
  }

  calcSelectePropertyAverage(inputData) {

    this.askingPrice = 0;
    this.noi = 0;
    this.capRate = 0;
    this.avgArea = 0;
    this.avgRemainingTerm = "";

    let totalNoi = 0;
    let list
    let data = this.propertylist.filter(x => inputData.includes(x.Id));
    if (data.length > 0 && !this.selectAll) {
      this.askingPrice = data.map(x => x.Price).reduce((a, b) => a + b, 0);

      // calculate noi
      this.noi = data.map(x => x.RentNOI).reduce((a, b) => a + b, 0);
      let unpricedDate = data.map(x => x.Unpriced).reduce((a, b) => a + b, 0);
      if (unpricedDate != null) {
        this.UnPriced = unpricedDate;
      }
      // calculate noi

      this.avgArea = data.map(x => x.BuildingSize).reduce((a, b) => a + b, 0);
      this.capRate = this.property.OnlyZCF ? 'ZCF' : String(parseFloat(((this.noi / this.askingPrice) * 100).toFixed(2)));
      //this.avgRemainingTerm = this.convertDaysToDateWithDecimal(data.map(x => x.WeightedRemaingterm).reduce((a, b) => a + (b > 0 ? b : 0) , 0) / data.length);         
    }
    else if (this.selectAll) {
      this.askingPrice = this.property.Price;
      if (this.property.Unpriced != null) {
        this.UnPriced = this.property.Unpriced;
      }
      this.noi = this.property.NetOperatingIncome == undefined ? this.property.RentNOI : this.property.NetOperatingIncome;
      this.avgArea = this.property.BuildingSize;
      this.capRate = this.property.OnlyZCF ? 'ZCF' : this.property.CapRate;
      this.avgRemainingTerm = this.property.PortfolioRemainingLeaseTerm == null ? (data.map(x => x.RemainingTerm).reduce((a, b) => a + (b > 0 ? b : 0), 0) / data.length) : this.property.PortfolioRemainingLeaseTerm;
    }
    //weighted average noi

    let totalRentNoi = data.filter(x => x.RemainingTerm > 0).map(x => x.RentNOI).reduce((a, b) => a + b, 0);
    data.forEach(x => {
      x.RentWeight = (x.RentNOI / totalRentNoi) * 100;
    })
    data.forEach(x => {
      x.YEARFRAC = x.RemainingTerm <= 0 ? 0 : this.YEARFRAC((this._validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this._validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this._validationService.convertUTCDateToLocalDate(x.LeaseExpiration), 0)
      x.WeightedRemaingterm = x.YEARFRAC * (x.RentWeight / 100)
    })
    this.avgRemainingTerm = this.convertDaysToDateWithDecimal(data.map(x => x.WeightedRemaingterm).reduce((a, b) => (a > 0 ? a : 0) + (b > 0 ? b : 0), 0));

    this.emitOnCheck();
  }


  convertDaysToDateWithDecimal(number) {
    let value = number.toFixed(1);
    let date = value.toString().split('.');
    let months = parseInt(((date[1] / 10) * 12).toString().split('.')[0]);
    return (parseInt(date[0]) > 0 ? date[0] + ' Years ' : "") + (months > 0 ? + months + ' Months' : "");
  }

  convertDaysToDate(numberOfDays) {
    let years = parseInt((numberOfDays / 365).toFixed());
    let months = parseInt(((numberOfDays % 365) / 30).toFixed());
    let ndays = parseInt(((numberOfDays % 365) % 30).toFixed());
    const yrs = years > 1 ? 'Years' : 'Year';
    const mnts = months > 1 ? 'Months' : 'Month';
    const days = ndays > 1 ? 'days' : 'day';

    if (years === 0 && months > 0) {
      return months + ' ' + mnts;
    }
    if (months > 0) {
      return years + ' ' + yrs + ' & ' + months + ' ' + mnts;
    }
    else if ((years < 1 && months < 1) || (years === 0 && months === 0)) {
      if (years === 0 && months === 0 && ndays > 0) {
        return ndays + ' ' + days;
      }
      return 'Expired';
    }
    return years + ' ' + yrs;
  }

  YEARFRAC(start_date, end_date, basis) {

    // Credits: David A. Wheeler [http://www.dwheeler.com/]

    // Initialize parameters
    var basis = (typeof basis === 'undefined') ? 0 : basis;
    var sdate = moment(new Date(start_date));
    var edate = moment(new Date(end_date));

    // Return error if either date is invalid
    if (!sdate.isValid() || !edate.isValid()) return '#VALUE!';

    // Return error if basis is neither 0, 1, 2, 3, or 4
    if ([0, 1, 2, 3, 4].indexOf(basis) === -1) return '#NUM!';

    // Return zero if start_date and end_date are the same
    if (sdate === edate) return 0;

    // Swap dates if start_date is later than end_date
    if (sdate.diff(edate) > 0) {
      var edate = moment(new Date(start_date));
      var sdate = moment(new Date(end_date));
    }

    // Lookup years, months, and days
    var syear = sdate.year();
    var smonth = sdate.month();
    var sday = sdate.date();
    var eyear = edate.year();
    var emonth = edate.month();
    var eday = edate.date();

    switch (basis) {
      case 0:
        // US (NASD) 30/360
        // Note: if eday == 31, it stays 31 if sday < 30
        if (sday === 31 && eday === 31) {
          sday = 30;
          eday = 30;
        } else if (sday === 31) {
          sday = 30;
        } else if (sday === 30 && eday === 31) {
          eday = 30;
        } else if (smonth === 1 && emonth === 1 && sdate.daysInMonth() === sday && edate.daysInMonth() === eday) {
          sday = 30;
          eday = 30;
        } else if (smonth === 1 && sdate.daysInMonth() === sday) {
          sday = 30;
        }
        return ((eday + emonth * 30 + eyear * 360) - (sday + smonth * 30 + syear * 360)) / 360;
        break;

      case 1:
        // Actual/actual
        var feb29Between = function (date1, date2) {
          // Requires year2 == (year1 + 1) or year2 == year1
          // Returns TRUE if February 29 is between the two dates (date1 may be February 29), with two possibilities:
          // year1 is a leap year and date1 <= Februay 29 of year1
          // year2 is a leap year and date2 > Februay 29 of year2

          var mar1year1 = moment(new Date(date1.year(), 2, 1));
          if (moment([date1.year()]).isLeapYear() && date1.diff(mar1year1) < 0 && date2.diff(mar1year1) >= 0) {
            return true;
          }
          var mar1year2 = moment(new Date(date2.year(), 2, 1));
          if (moment([date2.year()]).isLeapYear() && date2.diff(mar1year2) >= 0 && date1.diff(mar1year2) < 0) {
            return true;
          }
          return false;
        };
        var ylength = 365;
        if (syear === eyear || ((syear + 1) === eyear) && ((smonth > emonth) || ((smonth === emonth) && (sday >= eday)))) {
          if (syear === eyear && moment([syear]).isLeapYear()) {
            ylength = 366;
          } else if (feb29Between(sdate, edate) || (emonth === 1 && eday === 29)) {
            ylength = 366;
          }
          return edate.diff(sdate, 'days') / ylength;
        } else {
          var years = (eyear - syear) + 1;
          var days = moment(new Date(eyear + 1, 0, 1)).diff(moment(new Date(syear, 0, 1)), 'days');
          var average = days / years;
          return edate.diff(sdate, 'days') / average;
        }
        break;

      case 2:
        // Actual/360
        return edate.diff(sdate, 'days') / 360;
        break;

      case 3:
        // Actual/365
        return edate.diff(sdate, 'days') / 365;
        break;

      case 4:
        // European 30/360
        if (sday === 31) sday = 30;
        if (eday === 31) eday = 30;
        // Remarkably, do NOT change February 28 or February 29 at ALL
        return ((eday + emonth * 30 + eyear * 360) - (sday + smonth * 30 + syear * 360)) / 360;
        break;
    }
  }
}
